import React, { Fragment, useEffect, useRef, useState } from "react";
import {
    AppBar,
    FormControl,
    Grid,
    TextField,
    Box,
    Paper,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    withStyles,
    Button,
} from "@material-ui/core";
// import { AutoComplete } from "antd";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";
import { alpha } from '@material-ui/core/styles';
import HttpService from "../../services/httpService";
import { setLoading } from "../../redux/actions/appAction";
import { connect, useSelector } from "react-redux";
import { Modal } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { DownloadOutlined } from '@ant-design/icons';
import {
    CONST_USER_ID,
    PalaPrasanthKumarId,
    PalisettiTejaId,
    ROLENAME,
    SriKrishnaId,
    ThirumaleshId,
} from "../../utils";
import { Link } from 'react-router-dom'


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    tablecontainer: {
        display: "flex",
        margin: "25px auto", // Added auto for horizontal centering
        justifyContent: "center", // Center the container
        maxWidth: "1200px", // Add a max-width for larger screens
        padding: theme.spacing(2),
    },
    customTableContainer: {
        overflowX: "initial",
    },
    tableform: {
        display: "flex",
        width: "100%", // Changed from maxWidth to width
        maxWidth: "1000px", // More reasonable max-width
        textAlign: "center",
        margin: "0 auto", // Center the form
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        borderRadius: '8px',
    },
    clickableTableCell: {
        cursor: "pointer",
        textDecoration: "underline",
        color: theme.palette.primary.main,
        transition: "all 0.2s ease",
        "&:hover": {
            color: theme.palette.primary.dark,
        }
    },
    normalTableCell: {
        color: theme.palette.text.primary,
        transition: "all 0.2s ease",
        "&:hover": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            textDecoration: "underline",
        },
    },
    tableCell: {
        color: "#1C375D",
        cursor: "pointer",
        textDecoration: "underline",
        transition: "all 0.2s ease",
        "&:hover": {
            color: theme.palette.primary.dark,
        }
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(0, 2),
    },
    narrowTab: {
        minWidth: "fit-content",
        width: 65,
        padding: theme.spacing(1),
    },
    margin: {
        margin: theme.spacing(1),
    },
    activeButton: {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        color: "white !important",
        transition: "background-color 0.3s, color 0.3s",
        "&:hover": {
            backgroundColor: `${theme.palette.secondary.dark} !important`,
        }
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: theme.spacing(1, 2),
        marginRight: theme.spacing(1),
        borderRadius: '20px',
        width: '20%',
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#14419c",
            color: 'white',
            transform: 'translateY(-1px)',
        }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7',
        color: '#151921',
        padding: theme.spacing(1, 2),
        marginRight: theme.spacing(1),
        borderRadius: '20px',
        width: '20%',
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#e06666",
            color: 'white',
            transform: 'translateY(-1px)',
        }
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: 600,
        padding: theme.spacing(2),
        fontSize: '15px',
        width: "102%",
        '&:first-child': {
            borderTopLeftRadius: '8px',
        },
        '&:last-child': {
            borderTopRightRadius: '8px',
        }
    },
    body: {
        fontSize: 14,
        padding: theme.spacing(1.5, 2),
        color: theme.palette.text.primary,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: alpha(theme.palette.action.hover, 0.05),
        },
        "&:last-child": {
            "& td, & th": {
                borderBottom: 0,
            }
        },
        transition: "background-color 0.2s ease",
        "&:hover": {
            backgroundColor: alpha(theme.palette.action.hover, 0.1),
        }
    },
}))(TableRow);

const MWPSummary = (props) => {
    const classes = useStyles();
    const [value, setValue] = useState("");
    const { userDetails } = useSelector((state) => state.user);
    const [materialDeliveryData, setMaterialDeliveryData] = useState([]);
    const [underExecutionData, setUnderExecutionData] = useState([]);
    const [projectCompetionData, setProjectCompletionData] = useState([]);
    const [completedMwpData, setCompletedMwpData] = useState([]);
    const [factoryStageData, setFactoryStageData] = useState([]);
    const [factoryDataForOps1, setFactoryDataForOps1] = useState([]);
    const [completedProjectData, setCompletedProjectData] = useState([]);
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [detailDataArray, setDetailDataArray] = useState([]);
    const [title, setTitle] = useState("Dummy Title");
    const [csvData, setCsvData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const csvButtonRef = useRef(null);
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    const [ShowDesignSignOffRevokeDate, setShowDesignSignOffRevokeDate] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [cities, setCities] = useState([]);
    const [mwpSummaryTableCsvData, setMwpSummaryTableCsvData] = useState([]);
    const mwpSummaryTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [selectedCities, setSelectedCities] = useState([]);
    let includeExperienceCenter = detailDataArray.some(item => item.experienceCenterName !== "" && item.experienceCenterName !== null && item.experienceCenterName !== undefined);
    let includeFactoryBomCompletedDate = detailDataArray.some(item => item.factoryBomCompletedDate !== "" && item.factoryBomCompletedDate !== null && item.factoryBomCompletedDate !== undefined);
    let includeRevocationDate = detailDataArray.some(item => item.designSignoffRevokeDate !== "" && item.designSignoffRevokeDate !== null && item.designSignoffRevokeDate !== undefined);
    let includedesignerAndAdmName = detailDataArray.some(item => item.designManagerName !== "" && item.designManagerName !== null && item.designManagerName !== undefined);
    let includeChmName = detailDataArray.some(item => item.chmUserName !== "" && item.chmUserName !== null && item.chmUserName !== undefined);
    let includeCustomerName = detailDataArray.some(item => item.customerName !== "" && item.customerName !== null && item.customerName !== undefined);
    let includeCustomerAddress = detailDataArray.some(item => item.customerAddress !== "" && item.customerAddress !== null && item.customerAddress !== undefined);
    let includeContractQualityControlApproved = detailDataArray.some(item => item.contractQualityControlApproved !== "" && item.contractQualityControlApproved !== null && item.contractQualityControlApproved !== undefined);
    let includeContractQCManagerApproved = detailDataArray.some(item => item.contractQCManagerApproved !== "" && item.contractQCManagerApproved !== null && item.contractQCManagerApproved !== undefined);
    let includeContractDesignManagerApproved = detailDataArray.some(item => item.contractDesignManagerApproved !== "" && item.contractDesignManagerApproved !== null && item.contractDesignManagerApproved !== undefined);
    let includeContractCustomerApproved = detailDataArray.some(item => item.contractCustomerApproved !== "" && item.contractCustomerApproved !== null && item.contractCustomerApproved !== undefined);
    let includeContractFinanceApproved = detailDataArray.some(item => item.contractFinanceApproved !== "" && item.contractFinanceApproved !== null && item.contractFinanceApproved !== undefined);
    let includeMaterialDeliveryDate = detailDataArray.some(item => item.materialDispatchedDate !== "" && item.materialDispatchedDate !== null && item.materialDispatchedDate !== undefined);
    let includeActualCompletionDate = detailDataArray.some(item => item.executionCompletionDate !== "" && item.executionCompletionDate !== null && item.executionCompletionDate !== undefined);
    let includeExecutionMWPDate = detailDataArray.some(item => item.executionMWPDate !== "" && item.executionMWPDate !== null && item.executionMWPDate !== undefined);

    // Headers for csv file
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNo", label: "Lead No" },
        { key: "currentStage", label: "Stage" },
        { key: "departmentName", label: "Department" },
        { key: "cxName", label: "Client Name" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "cityName", label: "City Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
    ];

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNo", label: "Lead No." },
        { key: "stage", label: "Stage" },
        { key: "department", label: "Department" },
        { key: "valueInr", label: "Value (INR)" },
        { key: "city", label: "City" },
        { key: "experienceCenter", label: "Experience Center" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
        { key: "currentStage", label: "Current stage" },
        { key: "executionMWPDate", label: "Execution MWP Date" },
    ];

    if (ShowDesignSignOffRevokeDate) {
        tableHeaders.push({ key: "uniqueLeadNumber", label: "Unique Lead ID" });
        tableHeaders.push({ key: "designSignoffRevokeDate", label: "Design Sign-off HOLD Revoke Date" });
    }

    if (includeExperienceCenter) {
        headers.push({ key: "experienceCenter", label: "Experience Center" });
    }
    if (includeFactoryBomCompletedDate) {
        headers.push({ key: "factoryBomCompletedDate", label: "Factory Assignment Date" });
    }
    if (includeRevocationDate) {
        headers.push({ key: "revocationDate", label: "Design-Hold Revoke Date" });
    }
    if (includedesignerAndAdmName) {
        headers.push({ key: "designerAndAdmName", label: "Designer/ADM name" });
    }
    if (includeChmName) {
        headers.push({ key: "chmName", label: "CHM Name" });
    }
    if (includeCustomerName) {
        headers.push({ key: "customerName", label: "Customer name" });
    }
    if (includeContractQualityControlApproved) {
        headers.push({ key: "contractQualityControlApproved", label: "QC Approval" });
    }
    if (includeContractQCManagerApproved) {
        headers.push({ key: "contractQCManagerApproved", label: "QC Manager Approval" });
    }
    if (includeContractDesignManagerApproved) {
        headers.push({ key: "contractDesignManagerApproved", label: "ADM Approval" });
    }
    if (includeContractCustomerApproved) {
        headers.push({ key: "contractCustomerApproved", label: "Customer Approval" });
    }
    if (includeContractFinanceApproved) {
        headers.push({ key: "contractFinanceApproved", label: "Finance Approval" });
    }
    if (includeMaterialDeliveryDate) {
        headers.push({ key: "materialDeliveryDate", label: "Material Delivery Date" });
    }
    if (includeActualCompletionDate) {
        headers.push({ key: "actualCompletionDate", label: "Actual Completion Date" });
    }
    if (includeExecutionMWPDate) {
        headers.push({ key: "executionMWPDate", label: "MWP Completion Date" });
    }
    if (includeCustomerAddress) {
        headers.push({ key: "apartmentName", label: "Apartment Name" });
    }

    const formatToLakhs = (value) => {
        const valueInLakhs = value / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    };
    // Function to handle tab changes
    const handleChange = (newValue) => {
        setValue(newValue);
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
    };

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (diffValue) => {
        getCompletedMWPDataUserWise(selectedSearchType, searchInput);
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    // Function to get Project's count for ops-1 tab
    const getCompletedMWPDataUserWise = async (selectedSearchType, searchInput) => {
        props.setLoading(true);
        let obj = {
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : "",
            cityId: ""
        }
        try {
            const response = await HttpService.getCompletedMWPDataUserWise(obj);
            setCompletedMwpData(response.data);
        } catch (error) {
            console.log("Error Here ->", error);
        }
        props.setLoading(false);
    };


    // Function to show Details
    const showDetailedModalHandler = (data, text) => {
        try {
            let call = data.map((el) => el.currentStage);
            let checkStage = call.every((el) => el === 'Design Sign-off HOLD');
            setShowDesignSignOffRevokeDate(checkStage)
            setShowDetailedModal(true);
            setTitle(text);
            setDetailDataArray(data);
        } catch (error) {
            console.log("Error - ", error);
        }
    };

        // Trigger CSV download when data is ready
        useEffect(() => {
            if (triggerDownload && mwpSummaryTableCsvData.length > 0) {
                const timer = setTimeout(() => {
                    if (mwpSummaryTableCsvButtonRef.current?.link) {
                        try {
                            mwpSummaryTableCsvButtonRef.current.link.click();
                        } catch (error) {
                            console.error("Error triggering CSV download:", error);
                            props?.setSnackInfo("Error downloading CSV", "error");
                        }
                        setTriggerDownload(false);
                    } else {
                        // Retry if link is not ready
                        setTimeout(() => {
                            if (mwpSummaryTableCsvButtonRef.current?.link) {
                                mwpSummaryTableCsvButtonRef.current.link.click();
                                setTriggerDownload(false);
                            }
                        }, 200);
                    }
                }, 300);
                
                return () => clearTimeout(timer);
            }
        }, [triggerDownload, mwpSummaryTableCsvData]);
    
        // Function to generate CSV data for MWP Summary table
        const generateMwpSummaryTableCsvData = () => {
            try {
                if (!completedMwpData || completedMwpData.length === 0) {
                    return [];
                }
    
                // Generate monthYearHeadings (same logic as in component)
                const monthYearHeadings = Array.from(
                    new Set(
                        completedMwpData.flatMap((el) =>
                            el?.users?.flatMap(user => user?.monthlyData?.map((data) => data.monthYear))
                        )
                    )
                ).sort((a, b) => {
                    const [monthA, yearA] = a.split("-");
                    const [monthB, yearB] = b.split("-");
                    const fullYearA = parseInt(yearA, 10) + 2000;
                    const fullYearB = parseInt(yearB, 10) + 2000;
                    const dateA = new Date(fullYearA, new Date(Date.parse(`${monthA} 1, 2024`)).getMonth(), 1);
                    const dateB = new Date(fullYearB, new Date(Date.parse(`${monthB} 1, 2024`)).getMonth(), 1);
                    return dateA - dateB;
                });
    
                const csvRows = [];
    
                // Build header row
                const headerRow = {
                    "City": "",
                    "Execution Lead": ""
                };
    
                // Add month/year columns
                monthYearHeadings.forEach((monthYear) => {
                    headerRow[monthYear] = "";
                });
    
                // Add Count column
                headerRow["Count"] = "";
                csvRows.push(headerRow);
    
                // Add data rows - match table structure exactly
                completedMwpData.forEach((cityData) => {
                    const cityName = cityData._id?.cityName || "";
    
                    // Add a row for each user in the city
                    cityData.users?.forEach((userData) => {
                        const row = {
                            "City": cityName,
                            "Execution Lead": userData.user === "Grand Total" ? "" : userData.user
                        };
    
                        // Add count for each month/year
                        monthYearHeadings.forEach((monthYear) => {
                            const monthData = userData.monthlyData?.find((data) => data.monthYear === monthYear);
                            row[monthYear] = monthData?.count || 0;
                        });
    
                        // Add total count
                        row["Count"] = userData.count || 0;
    
                        csvRows.push(row);
                    });
                });
    
                return csvRows;
            } catch (error) {
                console.error("Error generating MWP summary table CSV:", error);
                return [];
            }
        };

    // Function to download csv
    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < detailDataArray.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: detailDataArray[i]?.erpProjectNo || "N/A",
                    leadNo: detailDataArray[i]?.lead_no,
                    currentStage: detailDataArray[i]?.currentStage,
                    departmentName: detailDataArray[i]?.departmentName,
                    cxName: detailDataArray[i]?.cxName,
                    totalValue: detailDataArray[i]?.grandTotal / 1.18 || "-",
                    cityName: detailDataArray[i]?.cityName,
                    salesWonDate: detailDataArray[i]?.leadWonDate
                        ? moment(detailDataArray[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: detailDataArray[i]?.customerDesignSignOffDate
                        ? moment(detailDataArray[i]?.customerDesignSignOffDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    materialDeliveryDate: detailDataArray[i]?.materialDispatchedDate
                        ? moment(detailDataArray[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: detailDataArray[i]?.executionCompletionDate
                        ? moment(detailDataArray[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    executionMWPDate: detailDataArray[i]?.executionMWPDate
                        ? moment(detailDataArray[i]?.executionMWPDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    designerAndAdmName: detailDataArray[i]?.designUserName + " / " + detailDataArray[i]?.designManagerName,
                    apartmentName: detailDataArray[i]?.customerAddress,
                    customerName: detailDataArray[i]?.customerName,
                    chmName: detailDataArray[i]?.chmUserName,
                    factoryBomCompletedDate: detailDataArray[i]?.factoryBomCompletedDate
                        ? moment(detailDataArray[i]?.factoryBomCompletedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    revocationDate: detailDataArray[i]?.designSignoffRevokeDate
                        ? moment(detailDataArray[i]?.designSignoffRevokeDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    experienceCenter: detailDataArray[i]?.experienceCenterName,
                    contractQualityControlApproved: detailDataArray[i]?.contractQualityControlApproved,
                    contractQCManagerApproved: detailDataArray[i]?.contractQCManagerApproved,
                    contractDesignManagerApproved: detailDataArray[i]?.contractDesignManagerApproved,
                    contractCustomerApproved: detailDataArray[i]?.contractCustomerApproved,
                    contractFinanceApproved: detailDataArray[i]?.contractFinanceApproved,
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     leadNo: "",
                //     totalValue: "",
                //     cityName: "",
                //     salesWonDate: "",
                //     designSignOffDate: "",
                //     materialDeliveryDate: "",
                //     actualCompletionDate: "",
                //     revocationDate: "",
                //     factoryBomCompletedDate: "",
                //     experienceCenter: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const tableCsvDownloadHandler = () => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < detailDataArray.length; i++) {
                const data = detailDataArray[i];
                let valueInr = "N/A";
                if (data?.grandTotal) {
                    valueInr = (data.grandTotal / 1.18)?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                    });
                }

                let obj = {
                    serialNo: i + 1,
                    projectCode: data?.erpProjectNo || "N/A",
                    leadNo: data?.lead_no || "N/A",
                    stage: data?.currentStage || "N/A",
                    department: data?.departmentName || "N/A",
                    valueInr: valueInr,
                    city: data?.cityName || "N/A",
                    experienceCenter: data?.experienceCenterName || "N/A",
                    salesWonDate: data?.leadWonDate
                        ? moment(data?.leadWonDate).utc().format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: data?.customerDesignSignOffDate
                        ? moment(data?.customerDesignSignOffDate).utc().format("DD-MM-YYYY")
                        : "-",
                    materialDeliveryDate: data?.materialDispatchedDate
                        ? moment(data?.materialDispatchedDate).utc().format("DD-MM-YYYY")
                        : "-",
                    actualCompletionDate: data?.executionCompletionDate
                        ? moment(data?.executionCompletionDate).utc().format("DD-MM-YYYY")
                        : "-",
                    currentStage: data?.currentStage || "N/A",
                    executionMWPDate: data?.executionMWPDate
                        ? moment(data?.executionMWPDate).utc().format("DD-MM-YYYY")
                        : "-",
                };

                if (ShowDesignSignOffRevokeDate) {
                    obj.uniqueLeadNumber = data?.uniqueLeadNumber || "N/A";
                    obj.designSignoffRevokeDate = data?.designSignoffRevokeDate
                        ? moment(data?.designSignoffRevokeDate).utc().format("DD-MM-YYYY")
                        : "-";
                }

                csvArray.push(obj);
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            });
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // Function verify User
    // const verifyDataVisibilityAccess = () => {
    // 	if (
    // 		findMatchingUser(userDetails?._id) ||
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.DataAnalyst || role.name === ROLENAME.FinanceManager
    // 		)
    // 	) {
    // 		setValue("Summary of Delivery");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.SeniorOperationManager || role.name === ROLENAME.Admin
    // 		)
    // 	) {
    // 		setValue("Ops-1");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.FactoryManager
    // 		) &&
    // 		userDetails?._id.toString() !== ThirumaleshId
    // 	) {
    // 		setValue("Ops-2 (Factory)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops ||
    // 				role.name === ROLENAME.Execution_Manager
    // 		) ||
    // 		userDetails?._id === SriKrishnaId
    // 	) {
    // 		setValue("Ops-3 (Execution)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionUser
    // 		) ||
    // 		userDetails?._id === PalisettiTejaId ||
    // 		userDetails?._id === PalaPrasanthKumarId
    // 	) {
    // 		setValue("Ops-3 (MWP)");
    // 	}
    // };

    // const dateFilterHandler = () => {
    // 	if (value === "Summary of Delivery")
    // 		getMaterialDeliveryDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	if (value === "Summary of Completion")
    // 		getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	if (value === "Stage-Value") {
    // 		getMaterialDeliveryDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 		getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 		getFactoryManagerDataForOps1Tab(selectedSearchType, searchInput);
    // 		getUnderExecutionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	} else if (value === "Ops-3 (Execution)") {
    // 		getUnderExecutionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	}
    // };

    const clearDateFilter = () => {
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
        getCompletedMWPDataUserWise("", "");
    };

    const getLocationList = async () => {

        try {
            const response = await HttpService.getLocationList();
            setCities(response.data);
        } catch (error) {
            props.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
    };
    const handleCityAutocompleteChange = async (event, newValue) => {
        const selectedIds = newValue.map(city => city._id); // Extract only city IDs

        let cityId = [...selectedIds];
        let obj = {
            cityId: cityId
        }
        try {
            const response = await HttpService.getCompletedMWPDataUserWise(obj);
            setCompletedMwpData(response.data);
        } catch (error) {
            console.log("Error Here ->", error);
        }

        setSelectedCities([...selectedIds]); // Update state with selected IDs
    };


    const monthYearHeadings = Array.from(
        new Set(
            completedMwpData.flatMap((el) =>
                el?.users?.flatMap(user => user?.monthlyData?.map((data) => data.monthYear))
            )
        )
    ).sort((a, b) => {
        const [monthA, yearA] = a.split("-");
        const [monthB, yearB] = b.split("-");

        // Convert two-digit year to four-digit
        const fullYearA = parseInt(yearA, 10) + 2000;
        const fullYearB = parseInt(yearB, 10) + 2000;

        // Convert month names to numerical values (Jan = 0, Feb = 1, ..., Dec = 11)
        const dateA = new Date(fullYearA, new Date(Date.parse(`${monthA} 1, 2024`)).getMonth(), 1);
        const dateB = new Date(fullYearB, new Date(Date.parse(`${monthB} 1, 2024`)).getMonth(), 1);

        return dateA - dateB;
    });

    useEffect(() => {
        // verifyDataVisibilityAccess();
        getCompletedMWPDataUserWise();
        getLocationList()
    }, []);
    return (
        <Fragment>
            <Fragment>
                <Paper style={{ padding: 10, marginLeft: 25 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                    <FormControl>
                        <Autocomplete
                            multiple
                            options={cities}
                            getOptionLabel={(option) => option.name}
                            style={{ width: 300, marginTop: "20px" }}
                            filterSelectedOptions
                            value={cities.filter(city => selectedCities.includes(city._id))}
                            onChange={handleCityAutocompleteChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Select City"
                                    placeholder="Choose multiple cities"
                                    autoComplete="off"  // Disable browser autofill
                                />
                            )}
                        />
                    </FormControl>


                </Paper>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px', marginLeft: 25 }}>
                    <CSVLink
                        data={mwpSummaryTableCsvData}
                        filename={`MWP_Summary_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={mwpSummaryTableCsvButtonRef}
                        style={{ textDecoration: 'none', display: 'none' }}
                    />
                    <Button
                        variant='contained'
                        startIcon={<DownloadOutlined />}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            const csvData = generateMwpSummaryTableCsvData();

                            if (csvData.length > 0) {
                                setMwpSummaryTableCsvData(csvData);
                                setTimeout(() => {
                                    setTriggerDownload(true);
                                }, 100);
                            } else {
                                props?.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.4rem 2rem"
                        }}
                    >
                        Download CSV
                    </Button>
                </div>
                <div
                    className={classes.tablecontainer}
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "24px",
                        width: "100%",
                        margin: "0 auto",
                    }}
                >
                    <div style={{ width: "100%" }}>
                        <TableContainer
                            component={Paper}
                            className={classes.table}
                            style={{
                                width: "100%",
                                borderRadius: "8px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                marginBottom: "24px",
                            }}
                        >
                            <Table
                                style={{
                                    width: "100%",
                                    margin: "0 auto",
                                    borderCollapse: "collapse"
                                }}
                                className={classes.table}
                                stickyHeader
                                aria-label="sticky table"
                            >
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell style={{ padding: "16px 24px", fontSize: "15px", fontWeight: "600", borderRight: "1px solid #ddd" }}>
                                            City
                                        </StyledTableCell>
                                        <StyledTableCell style={{ padding: "16px 24px", fontSize: "15px", fontWeight: "600", borderRight: "1px solid #ddd" }}>
                                            Execution Lead
                                        </StyledTableCell>
                                        {monthYearHeadings.map((monthYear) => (
                                            <StyledTableCell key={monthYear} style={{ padding: "16px 24px", fontSize: "15px", fontWeight: "600", borderRight: "1px solid #ddd" }}>
                                                {monthYear}
                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell style={{ padding: "16px 24px", fontSize: "15px", fontWeight: "600", borderRight: "1px solid #ddd" }}>
                                            Count
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                                <TableBody>
                                    {completedMwpData?.map((cityData, cityIndex) => {
                                        const isGrandTotal = cityData._id.cityName === "Grand Total";

                                        return (
                                            <React.Fragment key={cityIndex}>
                                                <StyledTableRow style={{ backgroundColor: isGrandTotal ? "#f0f0f0" : "inherit" }}>
                                                    <StyledTableCell
                                                        rowSpan={cityData.users?.length + 1}
                                                        style={{
                                                            padding: "12px 24px",
                                                            fontWeight: isGrandTotal ? "900" : "600",
                                                            textAlign: "center",
                                                            verticalAlign: "middle",
                                                            backgroundColor: isGrandTotal ? "#f0f0f0" : "inherit",
                                                            borderRight: "1px solid #ddd"
                                                        }}
                                                    >
                                                        {cityData._id.cityName}
                                                    </StyledTableCell>
                                                </StyledTableRow>

                                                {cityData.users?.map((userData, userIndex) => (
                                                    <StyledTableRow key={userIndex}>
                                                        <StyledTableCell
                                                            style={{
                                                                backgroundColor: isGrandTotal ? "#f0f0f0" : "white",
                                                                padding: "12px 24px",
                                                                fontWeight: isGrandTotal ? "700" : "400",
                                                                borderRight: "1px solid #ddd"
                                                            }}
                                                        >
                                                            {userData.user === "Grand Total" ? "" : userData.user}
                                                        </StyledTableCell>

                                                        {monthYearHeadings.map((monthYear) => {
                                                            const monthData = userData.monthlyData?.find((data) => data.monthYear === monthYear);
                                                            return (
                                                                <StyledTableCell
                                                                    key={monthYear}
                                                                    style={{
                                                                        backgroundColor: isGrandTotal ? "#f0f0f0" : "white",
                                                                        padding: "12px 24px",
                                                                        textAlign: "center",
                                                                        fontWeight: isGrandTotal ? "700" : "400",
                                                                        cursor: "pointer",
                                                                        borderRight: "1px solid #ddd"
                                                                    }}
                                                                    className={classes.tableCell}
                                                                    onClick={() => {
                                                                        showDetailedModalHandler(monthData?.data, "Ops-3 MWP | " + userData.user);
                                                                    }}
                                                                >
                                                                    {monthData?.count || "0"}
                                                                </StyledTableCell>
                                                            );
                                                        })}

                                                        <StyledTableCell
                                                            style={{
                                                                backgroundColor: "#f0f0f0",
                                                                padding: "12px 24px",
                                                                fontWeight: "700",
                                                                cursor: "pointer",
                                                                borderRight: "1px solid #ddd"
                                                            }}
                                                            className={classes.tableCell}
                                                            onClick={() => {
                                                                showDetailedModalHandler(userData?.data, "Ops-3 MWP | " + userData.user);
                                                            }}
                                                        >
                                                            {userData.count}
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                            </React.Fragment>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Fragment>
            <Modal
                title={title}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={title.replace("|", "-") + ".csv"}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(null)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB", marginRight: '10px' }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>

                {detailDataArray && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Stage</StyledTableCell>
                                    <StyledTableCell>Department</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Experience Center</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Material Delivery Date</StyledTableCell>
                                    <StyledTableCell>Actual Completion Date</StyledTableCell>
                                    {ShowDesignSignOffRevokeDate && <StyledTableCell>Unique Lead ID</StyledTableCell>}
                                    {ShowDesignSignOffRevokeDate && <StyledTableCell>Design Sign-off HOLD Revoke Date</StyledTableCell>}
                                    <StyledTableCell>Current stage</StyledTableCell>
                                    <StyledTableCell>Execution MWP Date</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {detailDataArray?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell component="th">{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.erpProjectNo || "N/A"} */}
                                                {
                                                    data.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.erpProjectNo}</Link> :
                                                        'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {/* {data?.lead_no} */}
                                                {
                                                    data.lead_no ?
                                                        <Link to={`/project-logs/${data._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.lead_no}</Link> :
                                                        'NA'
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.currentStage}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.departmentName}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.cxName|| "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {(data?.grandTotal / 1.18)?.toLocaleString("en-IN", {
                                                    maximumFractionDigits: 2, // Maximum number of decimal places
                                                    style: "currency",
                                                    currency: "INR",
                                                })}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.cityName || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.experienceCenterName || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.leadWonDate
                                                    ? moment(data?.leadWonDate).utc().format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerDesignSignOffDate
                                                    ? moment(data?.customerDesignSignOffDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.materialDispatchedDate
                                                    ? moment(data?.materialDispatchedDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.executionCompletionDate
                                                    ? moment(data?.executionCompletionDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            {ShowDesignSignOffRevokeDate && <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.uniqueLeadNumber}
                                            </StyledTableCell>}
                                            {ShowDesignSignOffRevokeDate && <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.designSignoffRevokeDate
                                                    ? moment(data?.designSignoffRevokeDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>}
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.currentStage || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.executionMWPDate
                                                    ? moment(data?.executionMWPDate)
                                                        .utc()
                                                        .format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </Fragment>
    );
};

export default connect(null, { setLoading })(MWPSummary);